import { mascaraMoeda, maskCurrency } from '../../../../utils/utils'
import { useCompany } from "../../../../hooks/useCompany"
import { Toast } from "../../../../utils/Toast"
import { api } from "../../../../api/api"
import { ModalImageCrop } from '../../../../components/Modals/ImageCrop'
import { useState } from 'react'
import CompanyService from '../../../../services/company';
import { DEFAULT_IMAGE } from '../../../../utils/constantes'
import { QRCodeCanvas } from 'qrcode.react';
import { DefineStyle } from './components/DefineStyle'
import { ConfigurationHelp } from './components/ConfigurationHelp'
import { TbHelpCircle } from 'react-icons/tb'

export function Configuration() {
  const { configurations, updateConfiguration, company } = useCompany()

  const [whenCrop, setWhenCrop] = useState('banner')

  async function save() {
    await api.post('/configurations', configurations)
    Toast.success()
  }

  function getUrlCardapio() {
    if (company.domain) {
      return `https://${company.domain}/${company.link}`
    } else {
      return `${process.env.REACT_APP_CARDAPIO}/${company.link}`
    }
  }

  const isDesktop = localStorage.getItem('isDesktop') === 'true'
  let printers = []

  try {
    printers = JSON.parse(localStorage.getItem('printers')) || []
  } catch {
    printers = []
  }

  return (
    <div className='mt-3 company-panel company-configuration-panel'>

      <ModalImageCrop
        uploadImageBanner={whenCrop === 'banner' ? CompanyService.uploadImageBanner : CompanyService.uploadLogo}
        title={whenCrop === 'banner' ? 'Cortar banner' : 'Cortar logo'}
        width={whenCrop === 'banner' ? 1200 : 600}
        height={whenCrop === 'banner' ? 675 : 600}
        aspect={whenCrop === 'banner' ? 16 / 9 : 1}
      />
      <ConfigurationHelp />
      <div className="banner p-2 company-banner-wrap">
        <div className="company-brand-grid" style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', gap: 20 }}>
          <div className="company-brand-card" style={{ display: "flex", flexDirection: 'column', alignItems: 'center', gap: 10 }}>
            <h2 className="text-center">Banner</h2>
            <img
              loading="lazy"
              style={{ width: window.screen.width < 1600 ? 350 : 500, height: 250, objectFit: 'contain' }}
              src={company.banner ?? DEFAULT_IMAGE}
              className="img-fluid col-sm-6 mb-4 rounded border" alt=""
            />
            <button className="btn btn-sm btn btn-sm company-secondary-btn" style={{ border: '1px solid #666' }} onClick={() => {
              setWhenCrop('banner')
              new window.bootstrap.Modal(document.getElementById('modalCropImage'), {}).toggle()
            }}>Enviar imagem</button>
          </div>
          <div className="company-brand-card" style={{ display: "flex", flexDirection: 'column', alignItems: 'center', gap: 10 }}>
            <h2 className="text-center">Logo</h2>
            <img
              loading="lazy"
              style={{ width: window.screen.width < 1600 ? 350 : 500, height: 250, objectFit: 'contain' }}
              src={company.logo ?? DEFAULT_IMAGE}
              className="border" alt=""
            />
            <button className="btn btn-sm btn btn-sm company-secondary-btn" style={{ border: '1px solid #666' }} onClick={() => {
              setWhenCrop('logo')
              new window.bootstrap.Modal(document.getElementById('modalCropImage'), {}).toggle()
            }}>Enviar imagem</button>
          </div>
        </div>

        <DefineStyle />

      </div>
      <section className="admin-surface company-settings-section">
        <header className="admin-surface-header company-settings-header">
          <div>
            <h2>Pedido e impressão</h2>
            <p>Configure o atendimento, os pedidos automáticos e as impressoras da loja.</p>
          </div>
          <button type="button" className="admin-secondary-button" data-bs-toggle="modal" data-bs-target="#configurationHelp">
            <TbHelpCircle size={18} />
            Ajuda
          </button>
        </header>

        <div className="company-settings-grid">
          <section className="company-settings-card">
            <div className="company-settings-card-title">
              <h3>Pedido e atendimento</h3>
              <p>Opções disponíveis para o cliente durante o pedido.</p>
            </div>
            <label htmlFor="pricingMinDelivery">Preço mínimo para entrega</label>
            <input
              id="pricingMinDelivery"
              className="form-control form-control-sm"
              onChange={(e) => updateConfiguration({ pricingMinDelivery: mascaraMoeda(e.target.value) })}
              value={maskCurrency(configurations.pricingMinDelivery)}
              type="text"
              inputMode="numeric"
            />
            <div className="company-settings-options">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.activeRetirada}
                  onChange={(e) => updateConfiguration({ activeRetirada: e.target.checked })}
                  id="ActiveRetirada" />
                <label className="form-check-label" htmlFor="ActiveRetirada">
                  Ativar retirada
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.activeRating}
                  onChange={(e) => updateConfiguration({ activeRating: e.target.checked })}
                  id="activeRating" />
                <label className="form-check-label" htmlFor="activeRating">
                  Ativar avaliação ao finalizar pedido
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.sound}
                  onChange={(e) => updateConfiguration({ sound: e.target.checked })}
                  id="activeSound" />
                <label className="form-check-label" htmlFor="activeSound">
                  Ativar som ao chegar um novo pedido
                </label>
              </div>
            </div>
          </section>

          <section className="company-settings-card">
            <div className="company-settings-card-title">
              <h3>Aceite automático</h3>
              <p>Defina quais confirmações podem acontecer sem ação manual.</p>
            </div>
            <div className="company-settings-options">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoAcceptedIfood}
                  onChange={(e) => updateConfiguration({ autoAcceptedIfood: e.target.checked })}
                  id="autoAcceptedIfood" />
                <label className="form-check-label" htmlFor="autoAcceptedIfood">
                  Aceitar pedidos do iFood automaticamente
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.automaticProductAcceptance}
                  onChange={(e) => updateConfiguration({ automaticProductAcceptance: e.target.checked })}
                  id="automaticProductAcceptance" />
                <label className="form-check-label" htmlFor="automaticProductAcceptance">
                  Aceitar produtos automaticamente
                </label>
              </div>
            </div>
          </section>

          <section className="company-settings-card company-settings-card-wide">
            <div className="company-settings-card-title">
              <h3>Impressão automática</h3>
              <p>Escolha quais eventos devem gerar uma impressão.</p>
            </div>
            <div className="company-print-options">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoPrintMesa}
                  onChange={(e) => updateConfiguration({ autoPrintMesa: e.target.checked })}
                  id="autoPrintMesa" />
                <label className="form-check-label" htmlFor="autoPrintMesa">Pedidos de mesa</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoPrintIfood}
                  onChange={(e) => updateConfiguration({ autoPrintIfood: e.target.checked })}
                  id="autoPrintIfood" />
                <label className="form-check-label" htmlFor="autoPrintIfood">Pedidos do iFood</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoPrintDelivery}
                  onChange={(e) => updateConfiguration({ autoPrintDelivery: e.target.checked })}
                  id="autoPrintDelivery" />
                <label className="form-check-label" htmlFor="autoPrintDelivery">Pedidos de delivery</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoPrintBalcao}
                  onChange={(e) => updateConfiguration({ autoPrintBalcao: e.target.checked })}
                  id="autoPrintBalcao" />
                <label className="form-check-label" htmlFor="autoPrintBalcao">Pedidos de balcão</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoPrintOrder}
                  onChange={(e) => updateConfiguration({ autoPrintOrder: e.target.checked })}
                  id="autoPrintOrder" />
                <label className="form-check-label" htmlFor="autoPrintOrder">Ao chegar um novo pedido</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoPrintOnAddProduct}
                  onChange={(e) => updateConfiguration({ autoPrintOnAddProduct: e.target.checked })}
                  id="autoPrintOnAddProduct" />
                <label className="form-check-label" htmlFor="autoPrintOnAddProduct">Produtos adicionados ao pedido</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.autoPrintSector}
                  onChange={(e) => updateConfiguration({ autoPrintSector: e.target.checked })}
                  id="autoPrintSector" />
                <label className="form-check-label" htmlFor="autoPrintSector">Imprimir em setores diferentes</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.printCancelProductOrder}
                  onChange={(e) => updateConfiguration({ printCancelProductOrder: e.target.checked })}
                  id="printCancelProductOrder" />
                <label className="form-check-label" htmlFor="printCancelProductOrder">Produto removido ou cancelado</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={configurations.printCancelOrder}
                  onChange={(e) => updateConfiguration({ printCancelOrder: e.target.checked })}
                  id="printCancelOrder" />
                <label className="form-check-label" htmlFor="printCancelOrder">Pedido cancelado</label>
              </div>
            </div>
          </section>

          <section className="company-settings-card company-settings-card-wide">
            <div className="company-settings-card-title">
              <h3>Aplicativo e impressora</h3>
              <p>Instale o aplicativo e selecione onde os pedidos serão impressos.</p>
            </div>

            <div className="company-printer-actions">
              <button type="button" className="btn btn-sm btn-primary" onClick={() => window.open('https://pedidos-images.s3.us-east-1.amazonaws.com/Unledu+Pedidos+-+Configura%C3%A7%C3%A3o+Impressora+Setup+2.0.1.exe', '_blank')}>
                Baixar configurador de impressão
              </button>

              {isDesktop && (
                <div className="register-field-group company-printer-select">
                  <label htmlFor="defaultNamePrint">Nome da impressora padrão</label>
                  <select
                    id="defaultNamePrint"
                    value={configurations.defaultNamePrint || ""}
                    onChange={(e) => updateConfiguration({ defaultNamePrint: e.target.value })}
                    className="form-control form-control-sm"
                  >
                    <option value="">Selecione</option>
                    {printers.map(printer => (
                      <option key={printer.name} value={printer.name || ''}>{printer.name}</option>
                    ))}
                  </select>
                </div>
              )}

              {isDesktop && configurations.id && (
                <button type="button" className="btn btn-primary btn-sm" onClick={async () => {
                  const confirm = await Toast.confirm('Usar este computador para impressão padrão?', 'Não', 'Sim')

                  if (confirm) {
                    const deviceNameCode = localStorage.getItem('deviceNameCode')
                    updateConfiguration({ defaultCodePrint: deviceNameCode })

                    await api.post('/configurations', {
                      ...configurations,
                      defaultCodePrint: deviceNameCode
                    })

                    Toast.success('Computador configurado como impressora padrão com sucesso!')
                  }
                }}>
                  Usar este computador como padrão
                </button>
              )}
            </div>

            <div className="company-print-message">
              <label htmlFor="messagePrint">Mensagem da impressão</label>
              <input
                id="messagePrint"
                className="form-control form-control-sm"
                onChange={(e) => updateConfiguration({ messagePrint: e.target.value })}
                value={configurations.messagePrint || ''}
                type="text"
                maxLength={200}
                aria-describedby="messagePrintHelp"
              />
              <div id="messagePrintHelp" className="form-text">Esta mensagem aparecerá no comprovante impresso.</div>
            </div>
          </section>
        </div>
      </section>


      <h5 className="text-gray card-title mt-3" style={{ fontSize: '1.2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        QRCode Cardápio
      </h5>
      <p>Ao escanear o QR Code, seu cliente terá acesso ao cardápio.</p>
      <br />
      <div>
        <QRCodeCanvas id='canva-qrcode' size={256} value={getUrlCardapio()} />
      </div>
      <button onClick={() => {
        var link = document.createElement('a');
        link.download = 'qrcode.png';
        link.href = document.getElementById('canva-qrcode').toDataURL()
        link.click();
      }} className='btn mt-2 company-secondary-btn' style={{ border: '1px solid #666' }}>Baixar QR Code</button>
      <div className="divider mt-3 mb-3"></div>

      <div className="text-start">
        <button className="admin-primary-button" onClick={() => save()}>Salvar informações</button>
      </div>
    </div>
  )
}
